import { Injectable } from '@angular/core';

import { BaseChartService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseChartService<T> extends BaseChartService<T> {
  protected constructor(baseRoute: string) {
    super(baseRoute);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
